import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import './FinStatistics.css';

const COLORS = ['#28a745', '#007bff', '#dc3545', '#ffc107'];

const calculateAggregatedStats = (routes) => {
  const stats = {
    closed: { count: 0, amount: 0 },
    open: { count: 0 },
    undelivered: { count: 0 },
  };

  routes.forEach(route => {
    if (route.receipts && Array.isArray(route.receipts)) {
      route.receipts.forEach(receipt => {
        if (receipt.status === 'Закрыта') {
          stats.closed.count += 1;
          stats.closed.amount += parseFloat(receipt.amount) || 0;
        } else if (receipt.status === 'Открыта') {
          stats.open.count += 1;
        } else if (receipt.status === 'Не доставлено') {
          stats.undelivered.count += 1;
        }
      });
    }
  });
  return stats;
};

const FinStatistics = () => {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  // Добавляем состояние для диапазона дат
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedDriver, setSelectedDriver] = useState('');
  const [drivers, setDrivers] = useState([]);
  // Состояние для выбранных маршрутов (несколько)
  const [selectedRoutes, setSelectedRoutes] = useState([]);


  const fetchRoutes = async () => {
    try {
      const response = await api.get('/routes/by-date', {
        params: {
          startDate: startDate.toISOString().split('T')[0],
          endDate: endDate.toISOString().split('T')[0],
        }
      });
      setRoutes(response);
      const allDrivers = response.map(route => route.driver);
      setDrivers([...new Set(allDrivers)]);
    } catch (error) {
      console.error('Ошибка при загрузке маршрутов:', error);
    } finally {
      setLoading(false);
    }
  };

  // Получаем маршруты по диапазону дат
  useEffect(() => {

    
    fetchRoutes();
  }, [startDate, endDate]);

  if (loading) {
    return <div>Загрузка...</div>;
  }

  



  // Фильтруем маршруты по выбранному водителю
  const filteredRoutes = routes.filter(route => !selectedDriver || route.driver === selectedDriver);
  // Если выбраны конкретные маршруты, отображаем их, иначе — все отфильтрованные
  const displayedRoutes = selectedRoutes.length > 0
    ? filteredRoutes.filter(route => selectedRoutes.includes(route.id))
    : filteredRoutes;

    const clearSelectedRoutes = () => {
      setSelectedRoutes([]);
    };

  const aggregatedStats = calculateAggregatedStats(displayedRoutes);
  const pieData = [
    { name: 'Закрытые', value: aggregatedStats.closed.count },
    { name: 'Открытые', value: aggregatedStats.open.count },
    { name: 'Не доставлено', value: aggregatedStats.undelivered.count }
  ];

  // Обработчик выбора/снятия выбора маршрута
  const handleRouteSelect = (routeId) => {
    if (selectedRoutes.includes(routeId)) {
      setSelectedRoutes(selectedRoutes.filter(id => id !== routeId));
    } else {
      setSelectedRoutes([...selectedRoutes, routeId]);
    }
  };

  // Кнопка "Посмотреть за весь день" — выбирает все маршруты за выбранный день (из фильтрованных)
  const handleWholeDayView = () => {
    const dayRoutes = filteredRoutes.map(route => route.id);
    setSelectedRoutes(dayRoutes);
  };

  // Кнопка "Посмотреть все маршруты" — выбирает все маршруты, загруженные на странице (без фильтра по водителю)
  const handleAllRoutesView = () => {
    const allRouteIds = routes.map(route => route.id);
    setSelectedRoutes(allRouteIds);
  };

    // Агрегация прибыли по виду оплаты из закрытых квитанций
  const profitByPaymentType = {};
  displayedRoutes.forEach(route => {
    if (Array.isArray(route.receipts)) {
      route.receipts.forEach(receipt => {
        if (receipt.status === 'Закрыта') {
          const paymentType = receipt.payment_type;
          const amount = parseFloat(receipt.amount) || 0;
          if (!profitByPaymentType[paymentType]) {
            profitByPaymentType[paymentType] = 0;
          }
          profitByPaymentType[paymentType] += amount;
        }
      });
    }
  });

  const profitData = Object.keys(profitByPaymentType).map(key => ({
    name: key,
    profit: profitByPaymentType[key]
  }));

  const profitColors = [
    '#0088FE', 
    '#00C49F', 
    '#FFBB28', 
    '#FF8042', 
    '#FF6384', 
    '#36A2EB', 
    '#FFCE56', 
    '#4BC0C0', 
    '#9966FF', 
    '#FF9F40'
  ];


  return (
    <div className="dashboard-container FinStats-dashboard-container">
      <h1>Финансовая статистика по маршрутам</h1>

      {/* Отдельная строка для изменения диапазона дней (RoutesFinancialStats) */}
      <div className="FinStats-date-range">
        <label>
          С:
          <input
            type="date"
            value={startDate.toISOString().split('T')[0]}
            onChange={(e) => setStartDate(new Date(e.target.value))}
          />
        </label>
        <label>
          По:
          <input
            type="date"
            value={endDate.toISOString().split('T')[0]}
            onChange={(e) => setEndDate(new Date(e.target.value))}
          />
        </label>
        {/*<button onClick={() => { /* Здесь можно добавить логику для обновления статистики при изменении диапазона  }}>
          RoutesFinancialStats
        </button>*/}
      </div>

      {/* Фильтр по водителю */}
      <div className="FinStats-filters">
        <label>
          Водитель:
          <select value={selectedDriver} onChange={(e) => setSelectedDriver(e.target.value)}>
            <option value="">Все водители</option>
            {drivers.map((driver, idx) => (
              <option key={idx} value={driver}>{driver}</option>
            ))}
          </select>
        </label>
        <button onClick={fetchRoutes} className="main-button">Обновить данные</button>
      </div>

{/* Компактное окно выбора маршрутов с отображением прогресса */}
<div className="FinStats-routes-selection">
  <h2>Выбор маршрутов</h2>
  <div className="FinStats-routes-list">
    {filteredRoutes.map(route => {
      const totalOrders = Array.isArray(route.receipts) ? route.receipts.length : 0;
      const delivered = Array.isArray(route.receipts)
        ? route.receipts.filter(r => r.status === 'Закрыта').length
        : 0;
      const inProgress = Array.isArray(route.receipts)
        ? route.receipts.filter(r => r.status === 'Открыта').length
        : 0;
      const undelivered = Array.isArray(route.receipts)
        ? route.receipts.filter(r => r.status === 'Не доставлено').length
        : 0;
        
      const deliveredPercent = totalOrders ? (delivered / totalOrders) * 100 : 0;
      const inProgressPercent = totalOrders ? (inProgress / totalOrders) * 100 : 0;
      const undeliveredPercent = totalOrders ? (undelivered / totalOrders) * 100 : 0;

      

      return (
        <div 
          key={route.id} 
          className={`FinStats-route-item ${selectedRoutes.includes(route.id) ? 'selected' : ''}`}
          onClick={() => handleRouteSelect(route.id)}
        >
          <div className="route-info">
            <span>{route.route_number}</span>
            <span>{route.driver}</span>
            {route.loader && <span>Грузчик: {route.loader}</span>}
            {route.region && <span>Район: {route.region}</span>}
          </div>
          <div className="progress-bar-progress">
            <div 
              className="progress-bar-delivered"
              style={{ width: `${deliveredPercent}%` }}
            />
            <div 
              className="progress-bar-in-progress"
              style={{ width: `${inProgressPercent}%` }}
            />
            <div 
              className="progress-bar-undelivered"
              style={{ width: `${undeliveredPercent}%` }}
            />
          </div>
          <div className="progress-text">
            <span>{delivered}/{totalOrders} доставлено</span>
            <span>{inProgress} в пути</span>
            <span>{undelivered} не доставлено</span>
          </div>
        </div>
      );
    })}
  </div>
  <div className="FinStats-routes-buttons">
    <button onClick={handleWholeDayView}>Посмотреть за весь день</button>
    <button onClick={handleAllRoutesView}>Посмотреть все маршруты</button>
    <button onClick={clearSelectedRoutes}>Снять выделение</button>
  </div>
</div>


      <div className="widgets-container FinStats-widgets-container">
        {/* Виджет: Общая статистика */}
        <div className="widget-card FinStats-widget-card">
          <h2>Общая статистика</h2>
          <p>Закрытых квитанций: {aggregatedStats.closed.count}</p>
          <p>Суммарная сумма закрытых: {aggregatedStats.closed.amount.toFixed(2)}</p>
          <p>Открытых квитанций: {aggregatedStats.open.count}</p>
          <p>Не доставлено: {aggregatedStats.undelivered.count}</p>
        </div>

        {/* Виджет: Статистика квитанций и прибыли */}
<div className="widget-card FinStats-widget-card">
  <h2>Статистика квитанций и прибыли</h2>
  <div className="FinStats-pie-charts-container">
    {/* Диаграмма для статусов квитанций */}
    <div className="FinStats-pie-chart">
      <h3>Статусы квитанций</h3>
      <PieChart width={300} height={300}>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          label
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </div>
    {/* Диаграмма для прибыли по виду оплаты */}
    <div className="FinStats-pie-chart">
      <h3>Прибыль по оплате</h3>
      <PieChart width={300} height={300}>
        <Pie
          data={profitData}
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
          dataKey="profit"
          label
        >
          {profitData.map((entry, index) => (
            <Cell key={`profit-cell-${index}`} fill={profitColors[index % profitColors.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </div>
  </div>
</div>


        

        {/* Виджет: Финансовая статистика по оплате */}
        <div className="widget-card FinStats-widget-card">
          <h2>Оплата по закрытым квитанциям</h2>
          {displayedRoutes.map(route => {
            const payments = {};
            route.receipts.forEach(receipt => {
              if (receipt.status === 'Закрыта') {
                const type = receipt.payment_type;
                if (!payments[type]) payments[type] = { count: 0, total: 0 };
                payments[type].count += 1;
                payments[type].total += parseFloat(receipt.amount) || 0;
              }
            });
            return (
              <div key={route.id} className="FinStats-route-payment-stats">
                <h3>Маршрут №{route.route_number} ({route.driver})</h3>
                {Object.keys(payments).length === 0 ? (
                  <p>Нет закрытых квитанций</p>
                ) : (
                  Object.entries(payments).map(([type, data]) => (
                    <p key={type}>
                      {type}: {data.count} квитанций, сумма: {data.total.toFixed(2)}
                    </p>
                  ))
                )}
              </div>
            );
          })}
        </div>
      </div>

      
    </div>
  );
};

export default FinStatistics;
